var $ = require('./scaffold');
var md = require('tfmarkdown');

var printContent = '';

$.send(calculatorPath+'config/print.md?'+(new Date()).getTime(), (resp) => {
	printContent = md.parse(resp.responseText, true);
});

module.exports = {
	serviceType: ['Residential', 'Commercial'],
	chartDropdown: ['Chart 1', 'Chart 2'],
	loadToggle: function(isTrue) {
		if (isTrue) {
			$.get('loadContent').style.display = 'inline-block';
			$.get('percentContent').style.display = 'none';
		} else {
			$.get('loadContent').style.display = 'none';
			$.get('percentContent').style.display = 'inline-block';
		}
		calc();
	},
	loanToggle: function(isTrue) {
		if (isTrue) {
			$.get('loanContent').style.display = 'inline-block';
		} else {
			$.get('loanContent').style.display = 'none';
		}
		calc();
	},
	pvToggle: function(isTrue) {
		if (isTrue) {
			$.get('pvContent').style.display = 'inline-block';
			$.get('percentPVContent').style.display = 'none';
		} else {
			$.get('pvContent').style.display = 'none';
			$.get('percentPVContent').style.display = 'inline-block';
		}
		calc();
	},
	printButton: {
		text: 'Print',
		func: function() {
			var childWindow = window.open(calculatorPath+'print.html');
			setTimeout(function() {
				var finalMessage = printContent.replace(/{{chart}}/g, '<img src="'+$.get('chartHolder').toDataURL('image/png', 0.9)+'" style="width: 6in;" />');
				finalMessage = finalMessage.replace(/{{chart2}}/g, '<img src="'+$.get('chartHolder2').toDataURL('image/png', 0.9)+'" style="width: 6in;" />');
				finalMessage = finalMessage.replace(/{{([a-zA-Z]+)}}/g, function(all, name) {
					var res = currentValues[name];
					if (!isNaN(res)) res = Math.round(res*1000)/1000;
					return res!==undefined ? res : '<span style="color: red">'+0+'</span>';
				});
				childWindow.postMessage(finalMessage, '*');
			}, 500);
		}
	},
	exportButton: {
		text: 'Export',
		func: function() {
			var a = document.createElement("a");

			var v = currentValues;
			var outd = [
				['MCCAC - On-line Solar PV Economic Calculator'],
				['Note: Results are very dependent on input values, the user takes responsibility to understand the inputs and outputs of this calculator'],
				['Use these results only as a guide'],
				['DC System Size (kW):', v.systemCapacity],
				['Estimated annual energy output (kWh)', v.annualOutput],
				['Total Project Cost', v.projectCost],
				['Rebate Amount', v.rebate],
				['Net Project Cost', v.netProjectCost],
				['Net Installed cost per DC watt', v.netInstalledCost],
				['Electrical Energy Rate ($/kWh)', v.electricityRate],
				['Transmission and Distribution ($/kWh)', v.TDrate],
				['Levelized Cost of PV Energy ($/kWh)', v.LCOE],
				['Levelized Avoided Cost of Grid Energy ($/kWh)', v.LACE],
				['Payback Period', v.paybackOutFinal],
				[],
				['Year', 'Discounted Annual PV Production (kWh)', 'Value of Electricity Produced ($/year)', 'Loan Payment', 'Total OM Cost ($)', 'Annual Cost of PV', 'NPV Factor', 'Accumulated PV Cost ($)', 'Accumulate Grid Cost ($)', 'Accumulated Energy Cost Grid ($/kWh)', 'Accumulated Energy PV Grid ($/kWh)']
			];
			for (var i=0; i<outd.length; i++) outd[i] = outd[i].join('\t');
			outd = outd.join('\n');

			var file = new Blob([outd], {type: 'text/plain'});
			a.href = URL.createObjectURL(file);
			a.setAttribute('download', 'output.csv');
			a.click();
			//window.open("data:application/csv," + encodeURIComponent('Cost,0'));
		}
	},
	uploadPvWatts: {
		text: 'Upload PVWatts CSV',
		func: function() {
			var fi = $.create('input', {type: 'file'});
			$.on(fi, 'change', function(e) {
				var file = e.target.files[0];
				var ext = file.name.split('.');
				ext = ext[ext.length-1];
				if (['tab', 'csv', 'txt'].indexOf(ext.toLowerCase()) === -1) {
					alert('File should have extension .tab, .csv or .txt');
					return;
				}
				var reader = new FileReader();
				reader.onload = function(fileData) {
					var pvWatts = fileData.target.result;
					pvWatts = pvWatts.replace(/"/g,'');
					pvWatts = pvWatts.split(/\r?\n/);
					var currentMonth = -1;
					var months = ["january","february","march","april","may","june","july","august","september","october","november","december"];
					for (var line of pvWatts) {
						line = line.split(',');
						if (line[0].indexOf('DC System Size') !== -1) {
							console.log('System Size: '+line[1]);
							$.get('systemCapacity').value = line[1]/1;
						}
						if (line[0] === '1' && currentMonth > -1) {
							alert('File error. Please ensure you downloaded the Monthly (not Hourly file from PV Watts).');
							return;
						} else if (line[0] === '1') currentMonth = 0;
						if (currentMonth > -1 && months[currentMonth]) {
							var field = $.get(months[currentMonth]+'Output');
							field.value = line[3];
							currentMonth++;
						}
					}
					calc();
				};
				reader.readAsText(file);
			});
			fi.click();
		}
	},
	loadError: {
		color: 'red'
	}
};